import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import { PARTNER_BILLING_PLAN_OPTION_ITEMS } from 'common/partnerConstants';

import { SR_API_ACTION_ADMIN_UPDATE_ITEM } from 'api/actionTypes';

import { createInitialValues, createFormValidationFn } from 'client/helpers/formikHelpers';

import ButtonDeprecated from 'client/components/ButtonDeprecated';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrFormikField, { SR_FIELD_THEME_PARTNER_FORM } from 'client/components/SrFormikField';

import postWithState from 'client/actions/postWithState';
import withApiState from 'client/helpers/withApiState';

const formFields = [
  {
    id: 'id',
    type: 'hidden',
  },
  {
    id: 'billingPlan',
    title: 'billing plan',
    type: 'select',
    properties: {
      choices: PARTNER_BILLING_PLAN_OPTION_ITEMS,
    },
    validations: ['required'],
  },
];

@withApiState({
  editPartnerApiState: {
    action: SR_API_ACTION_ADMIN_UPDATE_ITEM,
  },
})
class SrPartnerEditModal extends Component {
  static propTypes = {
    partner: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onSuccess: PropTypes.func,
    editPartnerApiState: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  _onSubmit = (partnerUpdates) => {
    const { onSuccess, dispatch } = this.props;

    dispatch(postWithState, {
      action: SR_API_ACTION_ADMIN_UPDATE_ITEM,
      payload: {
        table: 'partners',
        where: {
          id: partnerUpdates.id,
        },
        updates: partnerUpdates,
      },
      onSuccess: () => {
        if (typeof onSuccess === 'function') {
          onSuccess();
        }
      },
    });
  };

  render() {
    const { partner, editPartnerApiState, onClose } = this.props;

    return (
      <SrDarkModal className="SrPartnerEditModal">
        <SrModalContent onCloseIconClick={onClose}>
          <Formik
            validate={createFormValidationFn(formFields)}
            initialValues={createInitialValues({
              formFields: formFields,
              defaultValues: partner,
            })}
            onSubmit={this._onSubmit}
            render={(formikBag) => {
              return (
                <Form>
                  <div className="container">
                    <div className="header">
                      <span className="title">{`Edit ${partner.displayName}`}</span>
                    </div>
                    <div className="content">
                      {formFields.map((formField) => (
                        <SrFormikField
                          key={formField.id}
                          formField={formField}
                          formikBag={formikBag}
                          className={SR_FIELD_THEME_PARTNER_FORM}
                        />
                      ))}
                    </div>
                    <div className="footer">
                      <span onClick={onClose} className="cancelButton">
                        Cancel
                      </span>
                      <ButtonDeprecated
                        type="submit"
                        className="submitButton"
                        disabled={!formikBag.isValid || editPartnerApiState.inProgress}
                      >
                        {editPartnerApiState.inProgress ? 'saving...' : 'save'}
                      </ButtonDeprecated>
                      {editPartnerApiState.error && (
                        <div className="formMessageError">
                          <span>{editPartnerApiState.error}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </Form>
              );
            }}
          />
        </SrModalContent>
      </SrDarkModal>
    );
  }
}

SrPartnerEditModal.displayName = 'SrPartnerEditModal';

export default SrPartnerEditModal;
